export { default as StrategySpecialtyDropdown } from './StrategySpecialtyDropdown';
